var PES = PES || {};

PES.LoginOrRegisterModel = {
    isCheckoutFlow: ko.observable(true),
    email: ko.observable(""),
    password: ko.observable(""),
    loginOrRegisterValidation: {},
    passwordStrength: null,

    displayLogin: ko.observable(false),
    displayRegister: ko.observable(false),
    displayLoggedIn: ko.observable(false),
    displayForgotPassword: ko.observable(false),
    displayForgotPasswordSent: ko.observable(false),
    displayResendConfirmation: ko.observable(false),
    displayAccountRecognized: ko.observable(false),
    displayAccountRegister: ko.observable(false),
    emailIsInvalid: ko.observable(false),
    displayLoadingSpinner: ko.observable(true),
    displayEmailConfirmationRequired: ko.observable(false),
    displayResetPasswordExpired: ko.observable(false),
    timer: ko.observable(""),
    formattedTimer: ko.observable(""),
    displayForgotPasswordCountDownTimer: ko.observable(false),
    displayForceLoggedOut: ko.observable(false),

    displayLoginOrRegister: function () {
        var self = this;
        return !self.displayLogin() && !self.displayRegister() && !self.displayLoggedIn();
    },

    displayResetPasswordExpiredMessage: function () {
        return PES.Resources.DisplayResetPasswordExpiredMessage();
    },

    displayForceLoggedOutMessage: function () {
        return PES.Resources.DisplayForceLoggedOutMessage();
    },

    forgotPasswordSentMessage: ko.observable(""),
    forgotPasswordButtonMessage: ko.observable(""),

    tryClearPassword: function (mailRecognized) {
        var self = this;
        if ((mailRecognized && self.displayRegister()) ||
            (!mailRecognized && self.displayLogin()) ||
            (!mailRecognized && !self.displayRegister() && !self.displayRegister())) {
            self.clearPassword();
        }

    },

    clearPassword: function () {
        var self = this;
        self.password('');
        $('#password').trigger('change');
    },

    checkEmail: function () {
        var self = this;
        if (self.email == undefined) {
            self = this.loginOrRegister;
        }
        self.displayResetPasswordExpired(false);

        if (self.email() === '') {
            appendError("#email", PES.Resources.FieldRequired());
        }
        else if (self.loginOrRegisterValidation.errors()[0] === PES.Resources.NotValidEmailAddress()) {
            appendError("#email", PES.Resources.NotValidEmailAddress());
        }
        else if (self.loginOrRegisterValidation.errors().length !== 0 && self.password() !== '') {
            self.displayAccountRecognized(false);
            self.displayAccountRegister(false);
            self.emailIsInvalid(true);

            if (self.email() === '') {
                appendError("#email", PES.Resources.FieldRequired());
            }
        }
        else {
            var displayLoginOrRegister = self.displayLoginOrRegister();
            self.loginOrRegisterValidation.cleanGeneralErrors();
            self.emailIsInvalid(false);
            $.post("api/can-login", { email: self.email()})
                .done(function (response) {
                    var mailRecognized = response.EmailRegistered && response.LoginAllowed;

                    if (mailRecognized) {
                        self.startTimer(response.ResetPasswordRemainingCountDownSeconds);
                    }

                    self.tryClearPassword(mailRecognized);
                    self.displayLogin(false);
                    self.displayRegister(false);
                    self.displayResendConfirmation(false);
                    self.loginOrRegisterValidation.note("");

                    if (response.EmailRegistered) {

                        self.displayAccountRecognized(true);
                        self.displayAccountRegister(false);

                        if (resellerAttemptsToLoginAsCustomer(response.IsReseller, self.isReseller(), response.HasAnyPurchase)) {
                            self.loginOrRegisterValidation.note(PES.Resources.ResellerLoginAsCustomer());
                        }

                        if (!response.LoginAllowed && displayLoginOrRegister) {
                            self.loginOrRegisterValidation.cleanErrors();
                            self.loginOrRegisterValidation.generalErrors.push(PES.Resources.EmailConfirmationRequired());
                            self.displayResendConfirmation(true);
                        } else {
                            self.displayLogin(true);
                            self.displayEmailConfirmationRequired(!response.LoginAllowed);
                        }

                        $('.strengthify-wrapper').hide();
                    } else {
                        self.displayAccountRecognized(false);
                        self.displayAccountRegister(true);
                        self.displayRegister(true);
                    }
                })
                .fail(function () {
                    self.loginOrRegisterValidation.cleanErrors();
                    self.loginOrRegisterValidation.generalErrors.push(PES.Resources.DefaultErrorMessage());
                    self.loginOrRegisterValidation.note("");
                    self.displayAccountRecognized(false);
                    self.displayAccountRegister(false);
                });
        }
    },

    sendConfirmationLinkEmail: function () {
        var self = this;
        self.displayLoadingSpinner(true);
        self.loginOrRegister.displayLoadingSpinner(true);
        self.loginOrRegister.loginOrRegisterValidation.cleanErrors();
        var execute = function (token) {
            createOrUpdateInput(self.loginOrRegister.email(), "email", "resend-confirmation-link-form", "email-confirmation-link");
            $("input[name='__RequestVerificationToken']").val(token);
            var formData = $("#resend-confirmation-link-form").serialize();
            var formAction = $("#resend-confirmation-link-form").attr("action");
            $.post(formAction, formData)
                .done(function (data) {
                    if (data.Success) {
                        self.loginOrRegister.displayResendConfirmation(false);
                    } else {
                        data.Errors.forEach(function (error) {
                            self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(error);
                        });
                    }
                    self.displayLoadingSpinner(false);
                    self.loginOrRegister.displayLoadingSpinner(false);
                })
                .fail(function () {
                    self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(PES.Resources.DefaultErrorMessage());
                    self.displayLoadingSpinner(false);
                    self.loginOrRegister.displayLoadingSpinner(false);
                });
        }

        return regenerateAntiforgeryToken(execute);
    },

    goToForgotPassword: function () {
        var self = this;
        self.displayForgotPassword(true);
        self.displayForgotPasswordSent(false);
        self.forgotPasswordButtonMessage(PES.Resources.ResetPassword());
        if (self.timer > 0) {
            self.displayForgotPasswordCountDownTimer(true);
            $("#forgot-password-btn").prop('disabled', 'disabled');
        }
    },

    sendForgotPasswordEmail: function () {
        var self = this;
        self.displayLoadingSpinner(true);
        self.loginOrRegister.displayLoadingSpinner(true);
        self.loginOrRegister.displayForgotPasswordSent(false);
        self.loginOrRegister.loginOrRegisterValidation.cleanErrors();
        var execute = function (token) {
            createOrUpdateInput(self.loginOrRegister.email(), "email", "forgot-password-form", "email-reset-password");
            $("input[name='__RequestVerificationToken']").val(token);
            var formData = $("#forgot-password-form").serialize();
            var formAction = $("#forgot-password-form").attr("action");
            $.post(formAction, formData)
                .done(function (data) {
                    if (data.Success) {
                        self.loginOrRegister.forgotPasswordSentMessage(PES.Resources.ForgotPasswordSentMessage());
                        self.loginOrRegister.displayForgotPasswordSent(true);
                        self.loginOrRegister.forgotPasswordButtonMessage(PES.Resources.ResendLink());

                        if (data.ResetPasswordRemainingCountDownSeconds > 0) {
                            self.loginOrRegister.startTimer(data.ResetPasswordRemainingCountDownSeconds);
                            self.loginOrRegister.displayForgotPasswordCountDownTimer(true);
                            $("#forgot-password-btn").prop('disabled', 'disabled');
                        }
                    } else {
                        data.Errors.forEach(function (error) {
                            if (data.ResetPasswordRemainingCountDownSeconds > 0) {
                                self.loginOrRegister.forgotPasswordSentMessage(PES.Resources.ForgotPasswordSentMessage());
                                self.loginOrRegister.displayForgotPasswordSent(true);
                                self.loginOrRegister.forgotPasswordButtonMessage(PES.Resources.ResendLink());
                                self.loginOrRegister.startTimer(data.ResetPasswordRemainingCountDownSeconds);
                                self.loginOrRegister.displayForgotPasswordCountDownTimer(true);
                                $("#forgot-password-btn").prop('disabled', 'disabled');
                            } else {
                                self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(error);
                            }
                        });
                    }
                    self.displayLoadingSpinner(false);
                    self.loginOrRegister.displayLoadingSpinner(false);
                })
                .fail(function() {
                    self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(PES.Resources.DefaultErrorMessage());
                    self.displayLoadingSpinner(false);
                    self.loginOrRegister.displayLoadingSpinner(false);
                });
        }

        return regenerateAntiforgeryToken(execute);
    },

    goBackToLogin: function () {
        var self = this;
        self.loginOrRegister.displayForgotPassword(false);
        self.loginOrRegister.displayResendConfirmation(false);
        self.loginOrRegister.displayForgotPasswordSent(false);
        self.loginOrRegister.displayForgotPasswordCountDownTimer(false);
        self.loginOrRegister.loginOrRegisterValidation.cleanErrors();
    },

    toggleAccountMenu: function () {
        $.get("/user-dropdown-menu", function (data) {
            var jqAccountMenu = $('.account-menu')
            jqAccountMenu.children('li:not(.shopping-bag)').remove();
            jqAccountMenu.append(data);
        });
    },

    validate: function (checkoutViewModel, callbackFunction, callbackParam) {
        var self = checkoutViewModel;
        addPasswordValidation(self.loginOrRegister, true);
        clearError("#password", PES.Resources.IncorrectPassword());
        if (self.loginOrRegister.loginOrRegisterValidation.errors().length !== 0) {
            return 0;
        }

        addPasswordValidation(self.loginOrRegister, false);
        self.displayLoadingSpinner(true);
        self.loginOrRegister.displayLoadingSpinner(true);
        self.loginOrRegister.loginOrRegisterValidation.cleanErrors();
        var execute = function (token) {
            createOrUpdateInput(self.loginOrRegister.isCheckoutFlow(), "isCheckoutFlow", "login-or-register-form", "isCheckoutFlow-input-login-register");
            createOrUpdateInput(self.isReseller(), "isReseller", "login-or-register-form", "reseller-input-login-register");
            $("input[name='__RequestVerificationToken']").val(token);
            var jqLoginForm = $("#login-or-register-form");
            var formData = jqLoginForm.serialize();
            var formAction = jqLoginForm.attr("action");
            $.post(formAction, formData)
                .done(function (data) {
                    if (data.Success) {
                        localStorage.setItem('userCreated', self.loginOrRegister.displayRegister());

                        if (self.loginOrRegister.isCheckoutFlow()) {
                            self.loginOrRegister.displayLogin(false);
                            self.loginOrRegister.displayRegister(false);
                            self.loginOrRegister.displayLoggedIn(true);
                            self.loginOrRegisterSection.validated(true);

                            var updateLayout = function () {
                                self.reviewCartModel.getData();
                                callbackFunction(callbackParam);
                                self.displayLoadingSpinner(false);
                                self.loginOrRegister.displayLoadingSpinner(false);
                                addResellerCustomerEmailValidation(self);
                                self.loginOrRegister.password("");
                                self.loginOrRegister.toggleAccountMenu();
                            }

                            self.getAccountDetails(updateLayout);
                        } else {
                            var redirectUrl = jqLoginForm.serializeArray().filter(function (el) { return el.name === 'ReturnUrl'; })[0].value;
                            callbackFunction(data, redirectUrl);
                        }
                        return true;
                    } else {
                        data.Errors.forEach(function (error) {
                            if (error === PES.Resources.IncorrectPassword()) {
                                appendError("#password", error);
                            }
                            else {
                                self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(error);
                            }
                        });
                        self.displayLoadingSpinner(false);
                        self.loginOrRegister.displayLoadingSpinner(false);
                        return false;
                    }
                }).fail(function () {
                    self.loginOrRegister.loginOrRegisterValidation.generalErrors.push(PES.Resources.DefaultErrorMessage());
                    self.displayLoadingSpinner(false);
                    self.loginOrRegister.displayLoadingSpinner(false);
                    return false;
                });
        }
        return regenerateAntiforgeryToken(execute);
    },

    registerEventListeners: function (checkoutViewModel) {
        addEmailValidation(checkoutViewModel, true);

        var self = this;
        self.passwordStrength = new PES.PasswordStrengthModel('password', self);

        var email = document.getElementById("email");
        email.addEventListener("keydown", function (e) {
            if (e.keyCode === 13) {
                if (self.displayForgotPassword()) {
                    $("#forgot-password-btn").click();
                } else {
                    if (self.displayResendConfirmation()) {
                        $("#resend-confirmation-link").click();
                    } else {
                        if (self.displayLoginOrRegister()) {
                            $("#check-email-btn").click();
                        } else {
                            document.getElementById("password").focus();
                        }
                    }
                }
            }
        });

        email.addEventListener("keyup", function (e) {
            self.email(e.target.value.trim());
            if (!self.displayLoginOrRegister()) {
                self.checkEmail();
            } else if (self.email() !== '') {
                clearError("#email", PES.Resources.NotValidEmailAddress());
                $(email).removeClass('invalid');
            }
        });

        email.addEventListener("focusout", function (e) {
            if ($(email).hasClass('invalid')) {
                appendError("#email", PES.Resources.NotValidEmailAddress());
            }
        });

        var password = document.getElementById("password");

        password.addEventListener("keydown", function (e) {
            if (e.keyCode === 13) {
                setTimeout(function () { $("#login-or-register-btn").click(); }, 300);
            }
        });

        password.addEventListener("keyup", function (e) {
            var pass = $(e.target).val();
            if (pass.trim() === '') {
                appendError("#password", PES.Resources.FieldRequired());
            } else {
                clearError("#password", PES.Resources.IncorrectPassword());
                clearError("#password", PES.Resources.FieldRequired());
            }
        });

        email.addEventListener("focus", function (e) {
            if ($("label.top-negative-30").length) {
                $("label.top-negative-30").removeClass("top-negative-30");
            }
        });

        email.addEventListener("focusout", function (e) {
            if (self.displayEmailConfirmationRequired()) {
                self.displayLogin(false);
                self.displayRegister(false);
                self.displayResendConfirmation(false);
                self.loginOrRegisterValidation.note("");

                self.loginOrRegisterValidation.cleanErrors();
                self.loginOrRegisterValidation.generalErrors.push(PES.Resources.EmailConfirmationRequired());
                self.displayResendConfirmation(true);

                self.displayEmailConfirmationRequired(false);
            }
        });
    },

    startTimer: function (duration) {
        var self = this;
        self.timer = duration;
        var minutes, seconds;

        var calculateFormattedTimer = function () {
            var minutes = parseInt(self.timer / 60, 10);
            var seconds = parseInt(self.timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            return minutes + ":" + seconds;
        };

        self.formattedTimer(calculateFormattedTimer());
        var myInterval = setInterval(function () {
            self.formattedTimer(calculateFormattedTimer());

            if (--self.timer < 0) {
                clearInterval(myInterval);
                self.displayForgotPasswordCountDownTimer(false);
                $("#forgot-password-btn").prop('disabled', '');
            }
        }, 1000);
    }
}

function createOrUpdateInput(inputValue, inputName, formContainerId, inputElementId) {
    var inputElement = document.getElementById(inputElementId);
    if (inputElement == undefined) {
        inputElement = document.createElement("input");
        setInputAttributes(inputElement, inputElementId, inputValue, inputName);
        var loginOrRegisterForm = document.getElementById(formContainerId);
        loginOrRegisterForm.appendChild(inputElement);
    } else {
        setInputAttributes(inputElement, inputElementId, inputValue, inputName);
    }
}

function setInputAttributes(inputElement, inputElementId, inputValue, inputName) {
    inputElement.setAttribute("id", inputElementId);
    inputElement.setAttribute("type", "hidden");
    inputElement.setAttribute("name", inputName);
    inputElement.setAttribute("value", inputValue);
}

function regenerateAntiforgeryToken(callback) {
    $.get("/api/antiforgery-token", function (data) {
        callback(data.Token);
    });
}

function resellerAttemptsToLoginAsCustomer(emailUserIsReseller, resellerFlowSelected,hasAnyPurchase) {
    if (resellerFlowSelected && !emailUserIsReseller && hasAnyPurchase) {
        return true;
    }
    return false;
}

function addEmailValidation(checkoutViewModel, checkEmail) {
    var self = checkoutViewModel;
    if (!checkEmail) {
        self.loginOrRegister.email.extend({ validatable: false });
        return;
    }

    self.loginOrRegister.email.extend({
        required: {
            message: PES.Resources.FieldRequired(),
            onlyIf: function() {
                return checkEmail;
            }
        },
        email: { message: PES.Resources.NotValidEmailAddress() }
    });
}

function addPasswordValidation(loginOrRegisterModel, checkPwd) {
    var self = loginOrRegisterModel;
    if (!checkPwd) {
        self.password.extend({ validatable: false });
        return;
    }

    self.password.extend({
        required: {
            message: PES.Resources.FieldRequired(),
            onlyIf: function () {
                return !self.displayLoginOrRegister() && checkPwd;
            }
        }
    });
}

function addResellerCustomerEmailValidation(checkoutViewModel) {
    var self = checkoutViewModel;
    self.accountInformation.resellerCustomerDetails.email.extend({
        required: { message: PES.Resources.FieldRequired() },
        email: { message: PES.Resources.NotValidEmailAddress() },
        notEqual: {
            params: self.loginOrRegister.email(),
            message: PES.Resources.CustomerEmailSameAsReseller()
        }
    });
}

function appendError(element, error) {
    $(element).siblings(".validationMessage").text(error).show();
}

function clearError(element, error) {
    if ($(element).siblings(".validationMessage").text() === error) {
        $(element).siblings(".validationMessage").text("").css("display", "none");
    }
}